"use strict";exports.v=t=>({width:t||"100%",height:"100%",display:"block"});